var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "AddressSearchComponent" }, [
    _c("div", { staticClass: "flex drug_select_block" }, [
      _c(
        "div",
        { staticClass: "maxWidth" },
        [
          _c(
            "v-select",
            {
              ref: "select",
              staticClass: "search_input",
              attrs: {
                label: "title",
                placeholder: "Адрес доставки",
                filterable: false,
                appendToBody: true,
                options: _vm.suggestions,
              },
              on: {
                input: _vm.selectDrug,
                "search:focus": _vm.fillSearch,
                search: _vm.searchDrug,
              },
              nativeOn: {
                keypress: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    $event.preventDefault()
                  },
                  function ($event) {
                    return _vm.fastSearchCheck.apply(null, arguments)
                  },
                ],
              },
              scopedSlots: _vm._u([
                {
                  key: "option",
                  fn: function (option) {
                    return [
                      _c("div", { staticClass: "d-center text-wrap" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(option.title) +
                            "\n            "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "selected-option",
                  fn: function (option) {
                    return [
                      _c("div", { staticClass: "text-wrap" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(option.title) +
                            "\n          "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.record,
                callback: function ($$v) {
                  _vm.record = $$v
                },
                expression: "record",
              },
            },
            [
              _c("template", { slot: "no-options" }, [
                _vm._v("\n          введите адрес доставки..\n        "),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.record
        ? _c(
            "div",
            { staticClass: "map_tooltip_btn" },
            [
              _c(
                "v-popover",
                {
                  attrs: {
                    "auto-hide": true,
                    Class: "h-100",
                    popoverClass: "order_address_map_popover",
                    popoverInnerClass: "order_address_map_popover_inner",
                    delay: { show: 100, hide: 500 },
                  },
                },
                [
                  _c(
                    "button",
                    { staticClass: "btn btn-outline-info mr-1 h-100" },
                    [_c("i", { staticClass: "icon-fa icon-fa-map-marker" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "popover" },
                    [
                      _c("AddressMap", {
                        attrs: {
                          orderId: _vm.$editNewOrder?.id,
                          cityId: _vm.$editNewOrder.city_id,
                          address: _vm.record?.title,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }